
define('text!templates/modules/questionnaire/list/questionnaire-list-item.html',[],function () { return '<div class="item-section"></div>\n';});

